import React from "react";
import { ProductCard } from "./ProductCard";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";

export const RecentProduct = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get("/product/public/shows")
      .then((res) => {
        const productData = res.data.data?.products;
        setProducts(productData);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="container-fluid pt-5 pb-3">
      <h2 className="section-title position-relative text-uppercase mx-xl-5 mb-4 text-2xl font-bold">
        <span className="bg-secondary pr-3">Sản phẩm</span>
      </h2>
      <div className="row px-xl-5">
        {products.map((product, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </div>
  );
};
